import Wix from "Wix";
import axios from 'axios';
import httpRequest from "./httpRequests"
import parameters from '../../config/parameters.json';

/**
 * load google drive
 * @param {Function} callback called after load drive
 */
const loadDrive = (callback , isSettings = false) => {
  isSettings = window.location.search.substr(1).indexOf("endpointType=settings") > -1 ||
  window.location.pathname.indexOf("/settings/popup") > -1
  ? 1 : 0;
  let f = setInterval(() => {
      if (window.gapi.client) {
          let token = isSettings ? JSON.parse(window.localStorage.getItem('token')): '';
          if (token) {
            window.gapi.client.setToken({ access_token: token });
            if (!window.gapi.client.drive) {
              window.gapi.client.load("drive", "v2", callback);
            } else {
                callback();
            }
            clearInterval(f);
          }
      }
  }, 50);
};
/**
 * Get all fiel's in folder.
 * @param {String} folderId Id of the folder.
 * @param {Function} callback Get all files of folder.
 */

const retrieveAllFilesByFolderId = (folderId, resourceKey="",callback , searchText = "") => {
  const getFiels = () => {

    axios.get("/api/getFiles"+ httpRequest.getUrlQuery()+ "&fileId=" + folderId + "&searchText=" + searchText + "&resourceKey=" + resourceKey)
    .then(resp => {
      callback(resp.data);
    })
    .catch(error => {
    console.log(error.response)
  });
  }

  //loadDrive(getFiels);
  getFiels();
};

/**
 * Print a file's metadata.
 * @param {String} fileId ID of the file to print metadata for.
 * @param {Function} callback get file description.
 */
const getFileByFileId = (fileId,resourceKey ,callback) => {
  if (typeof fileId == "undefined" || fileId == parameters['DEFAULT_FILE'])
    callback(null);
  else axios.get("/api/getFileByFileId"+ httpRequest.getUrlQuery()+ "&fileId=" + fileId  + "&resourceKey=" + resourceKey)
  .then(resp => {
    callback(resp.data);
    })
    .catch(error => {
    console.log(error.response)
  });
};

export { getFileByFileId, retrieveAllFilesByFolderId, loadDrive };



// WEBPACK FOOTER //
// ./src/widget/api/GoogleDriveApi.js